<div class="w-full" data-testid="timelineTable">
  <div
    #gridContainer
    class="w-full overflow-auto overscroll-contain"
    [style.max-height.px]="maxHeight()"
  >
    <ag-grid-angular
      [rowData]="rows()"
      [gridOptions]="tableDef()"
      class="ag-theme-alpine timeline-grid w-full"
    ></ag-grid-angular>
  </div>
  <div class="flex justify-center items-center w-full py-2">
    @if (isLoading()) {
      <app-pan-spinner></app-pan-spinner>
    } @else if (noMoreData()) {
      <span class="text-sm text-gray-500">No more transactions found within 6 hours of the last.</span>
    } @else if (showViewMore()) {
      <app-pan-button color="primary" (click)="onViewMoreClick()">View More Transactions</app-pan-button>
    }
  </div>
</div>
